import React from "react";

import moment from "moment";

import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    CircularProgress,
} from "@mui/material";

const classes = {
    loadingContainer: {
        height: "100px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
};

export default function DeviceCommsTable({ loading, receivedCalls, emptyResponse }) {
    const calculateDateDiff = (start, end) => {
        let years = start.diff(end, "year");
        end.add(years, "years");

        let months = start.diff(end, "months");
        end.add(months, "months");

        let days = start.diff(end, "days");
        end.add(days, "days");

        let hours = start.diff(end, "hours");
        end.add(hours, "hours");
        if (hours.toString().length === 1) hours = "0" + hours;

        let minutes = start.diff(end, "minutes");
        end.add(minutes, "minutes");
        if (minutes.toString().length === 1) minutes = "0" + minutes;

        let seconds = start.diff(end, "seconds");
        end.add(seconds, "seconds");
        if (seconds.toString().length === 1) seconds = "0" + seconds;

        return { years, months, days, hours, minutes, seconds };
    };

    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table" stickyHeader>
                {!loading && receivedCalls?.length ? (
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Dttm (GMT+0)</TableCell>
                            <TableCell align="center">Age</TableCell>
                            {receivedCalls.find((call) => call.edge_device_id) && (
                                <>
                                    <TableCell align="center">Compressed Pts</TableCell>
                                    <TableCell align="center">Raw Pts</TableCell>
                                </>
                            )}
                        </TableRow>
                    </TableHead>
                ) : null}

                <TableBody>
                    {/* Show list of received calls */}
                    {!loading && receivedCalls?.length
                        ? receivedCalls.map((call) => {
                              let { compressed_scan_output, raw_scan_output } = call;
                              let receivedCallDttm = call.received_timestamp ?? call.dttm;
                              let callDttm = moment(receivedCallDttm);
                              let utcDateTime = moment(callDttm).format("MMMM DD, YYYY HH:mm:ss");
                              let currentDttm = moment(new Date());

                              let { years, months, days, hours, minutes, seconds } = calculateDateDiff(
                                  currentDttm,
                                  callDttm
                              );

                              let callAge;

                              if (years || months || days) {
                                  callAge = `${years} years ${months} months ${days} days \n ${hours}:${minutes}:${seconds}`;
                              } else {
                                  callAge = `${hours}:${minutes}:${seconds}`;
                              }

                              return (
                                  <TableRow key={utcDateTime}>
                                      <TableCell align="center">{utcDateTime}</TableCell>
                                      <TableCell style={{ whiteSpace: "pre-wrap" }} align="center">
                                          {callAge}
                                      </TableCell>
                                      {compressed_scan_output >= 0 && (
                                          <TableCell align="center">{compressed_scan_output}</TableCell>
                                      )}
                                      {raw_scan_output >= 0 && <TableCell align="center">{raw_scan_output}</TableCell>}
                                  </TableRow>
                              );
                          })
                        : null}

                    {/* Display message if no received calls */}
                    {!receivedCalls?.length && emptyResponse ? (
                        <TableRow>
                            <TableCell align="center">
                                No calls received for that device ID in the past 24 hours.
                            </TableCell>
                        </TableRow>
                    ) : null}

                    {loading ? (
                        <TableRow sx={classes.loadingContainer}>
                            <TableCell>
                                <CircularProgress />
                            </TableCell>
                        </TableRow>
                    ) : null}
                </TableBody>
            </Table>
        </TableContainer>
    );
}
